import { http } from '../index';

export const getTrainingPartsList = params =>
  http
    .get('/training-parts/list', { params })
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const getTrainingPart = id =>
  http
    .get(`/training-parts/${id}`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const getTrainingPartImpactedSessions = id =>
  http
    .get(`/training-parts/${id}/impacted-sessions`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const getTrainingPartsImpactedSessions = trainingPartIds =>
  http
    .get('/training-parts/impacted-sessions', {
      params: { trainingPartIds: (trainingPartIds || []).join(',') },
    })
    .then(res => res.data)
    .catch(error => error.response?.data || error);

const LAUNCHED_TRAINING_PART_STATUSES = new Set(['scheduled', 'active', 'retired']);

export const getPreviousTrainingPart = async (trainingModuleId, trainingMethod) => {
  const result = await getTrainingPartsList({
    trainingModuleId,
    trainingMethod,
    page: 0,
    pageSize: 100,
    complianceFrom: 'DESC',
  });

  if (result?.error || result?.statusCode) {
    return result;
  }

  const previous =
    (result?.items || []).find(item => LAUNCHED_TRAINING_PART_STATUSES.has(item.status)) || null;

  return {
    ...result,
    items: previous ? [previous] : [],
    count: previous ? 1 : 0,
  };
};

export const createTrainingPart = formData =>
  http
    .post('/training-parts', formData)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const updateTrainingPart = (id, formData) =>
  http
    .put(`/training-parts/${id}`, formData)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const launchTrainingPart = id =>
  http
    .post(`/training-parts/${id}/launch`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const cancelTrainingPart = id =>
  http
    .post(`/training-parts/${id}/cancel`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const deleteTrainingPart = id =>
  http
    .delete(`/training-parts/${id}`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);
